(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  const labels = new Map([
    ['COMPRE MAIS E POUPE!', 'BUY MORE & SAVE!'],
    ['Comprar 1', 'Buy 1'],
    ['Leve 2 e poupe', 'Buy 2 & save'],
    ['Leve 3 — Melhor oferta', 'Buy 3 — Best value'],
    ['Preço normal', 'Regular price'],
    ['Poupe 10%', 'Save 10%'],
    ['Poupe 15%', 'Save 15%']
  ]);
  let queued = false;
  const translate = () => {
    queued = false;
    document.querySelectorAll('.bundler-volume-target-element .bndlr-line, .bundler-volume-target-element .bndlr-text, .bundler-volume-target-element .bndlr-savings-text').forEach(element => {
      const translated = labels.get(element.textContent.trim());
      if (translated) element.textContent = translated;
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(translate);
  };
  translate();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
